import React, {useState} from "react";
import NumericInput from "react-numeric-input";
import inventoryService from "../services/inventory.service";
import _ from "lodash";
import Toaster from "../common/ToastMsg";
import {toast} from "react-toastify";

const InventoryItem = ({clientId, item, inv}) => {
    const [qty, setQty] = useState(item.qty);
    const [location, setLocation] = useState(item.location);
    const [listPrice, setListPrice] = useState(item.listPrice);
    const [cost, setCost] = useState(item.cost);
    const [isEdited, setIsEdited] = useState(false);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const handleCancelClick = () => {
        console.log(item);
        setLocation(item.location);
        setCost(item.cost);
        setListPrice(item.listPrice);
        setQty(item.qty);
        setIsEdited(false);
    }

    const handleDeleteClick = () => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm("Are you sure you want to delete " + item.emsParts.partsName + " ## " + item.emsParts.partsNumber)) {
            setDeleting(true);
            inventoryService.deleteParts(clientId, item.id).then(
                response => {
                    _.remove(inv, i => i.id === item.id);
                    setDeleting(false);
                    toast.info("inventory deleted!", {
                        position: "top-center",
                        containerId: "inventory",
                        autoClose: 2000
                    });
                },
                error => {
                    console.log(error);
                    setDeleting(false);
                    Toaster.error({
                        title: "Failed to delete inventory !",
                        text: error.message
                    }, {
                        position: "top-center",
                        containerId: "inventory",
                        autoClose: 3000
                    });
                }
            );
        }
    }

    const handleSaveClick = () => {
        if (qty !== item.qty || location !== item.location || cost !== item.cost || listPrice !== item.listPrice) {
            setSaving(true);
            inventoryService.updateInventory(clientId, item.id, item.emsParts.id, qty, cost, listPrice, location, false).then(
                (response) => {
                    item.qty = qty;
                    item.location = location;
                    item.cost = cost;
                    item.listPrice = listPrice;
                    setIsEdited(false);
                    setSaving(false);
                    toast.info("inventory updated!", {
                        position: "top-center",
                        containerId: "inventory",
                        autoClose: 2000
                    });
                },
                (error) => {
                    console.log(error);
                    setSaving(false);
                    Toaster.error({
                        title: "Failed to update inventory !",
                        text: error.message
                    }, {
                        position: "top-center",
                        containerId: "inventory"
                    });
                }
            );
        } else {
            toast.warn("item doesn't change!", {
                position: "top-center",
                containerId: "inventory"
            });
        }
    };

    return (
        <tr>
            <td>

                {item.hasPhoto && (
                    <div>
                        <a href={`/parts-photo?inventoryId=${item.id}`} target="_blank" rel="noopener noreferrer" title="Click to view photos">
                            *<strong>{item.id}</strong>*
                        </a>
                    </div>
                )}
                {!item.hasPhoto && (
                    <div>
                            *<strong>{item.id}</strong>*
                    </div>
                )}
            </td>
            <td>{item.emsParts.partsNumber}</td>
            <td>
                {item.emsParts.partsNames.slice(0, 5).map((partName, index) => (
                    <p key={index}>{partName}</p>
                ))}
                {item.emsParts.partsNames.length > 5 &&
                    <p>
                        <span title={item.emsParts.partsNames.join('\n')}>...</span>
                    </p>
                }
            </td>
            <td>
                <textarea className="form-control form-control-sm" rows="2" style={{ minWidth: '150px' }} value={location} onChange={e => {
                    setLocation(e.target.value);
                    setIsEdited(true);
                }}/>
            </td>
            <td>
                <NumericInput min={1} value={qty} precision={0} className="form-control"
                              onChange={(vn, vs, _) => {
                                  console.log("current value: " + vn + " previous value: " + vs + " qty: " + qty);
                                  setQty(vn);
                                  setIsEdited(true);
                              }
                              }
                />

            </td>
            <td>
                <NumericInput min={0} value={listPrice} precision={2} className="form-control"
                              onChange={(vn, vs, _) => {
                                  setListPrice(vn);
                                  setIsEdited(true);
                              }}
                />
            </td>
            <td>
                <NumericInput min={0} value={cost} precision={2} className="form-control"
                              onChange={(vn, vs, _) => {
                                  setCost(vn);
                                  setIsEdited(true);
                              }}
                />
            </td>
            <td>
                <div className="d-flex flex-wrap gap-2">
                    <button onClick={handleSaveClick} disabled={!isEdited || saving || deleting} className="btn btn-sm btn-primary rounded-pill px-3 shadow-sm flex-grow-1">
                        {saving && <span className="spinner-border spinner-border-sm me-1" role="status"></span>}
                        {saving ? "Saving..." : <><i className="bi bi-save me-1"></i>Save</>}
                    </button>
                    {isEdited &&
                        <button onClick={handleCancelClick} disabled={!isEdited || saving || deleting} className="btn btn-sm btn-secondary rounded-pill px-3 shadow-sm flex-grow-1">
                            <i className="bi bi-x-circle me-1"></i>Cancel
                        </button>
                    }
                    <button onClick={handleDeleteClick} disabled={saving || deleting} className="btn btn-sm btn-danger rounded-pill px-3 shadow-sm flex-grow-1">
                        {deleting && <span className="spinner-border spinner-border-sm me-1" role="status"></span>}
                        {deleting ? "Deleting..." : <><i className="bi bi-trash me-1"></i>Delete</>}
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default InventoryItem;
